import React, { useState, useEffect, lazy } from "react";
import { Link } from "react-router";
import LazyVideo from "../wegats/lazyvideo";
import { PersonAdd, CreditCard, Gamepad } from "@material-ui/icons";
import LandingSection from "../landingsection";

const steps = [
  {
    number: 1,
    icon: PersonAdd,
    title: "Sign Up & Login",
    description: "Create your account in seconds",
  },
  {
    number: 2,
    icon: CreditCard,
    title: "Make a Deposit",
    description: "Add funds securely",
  },
  {
    number: 3,
    icon: Gamepad,
    title: "Choose & Play",
    description: "Select your game and start winning",
  },
];

const Section01 = () => {
  const [SmallDevices, setScreen] = useState(false);

  useEffect(() => {
    setScreen(window.innerWidth > 991 ? false : true);
  }, []);

  return (
    <>
      <div className="play-btn-banner py-4 mb-4">
        <button className="box-shadow px-6 bg-gradient-to-b from-yellow-400 to-yellow-600 text-black font-bold rounded-md shadow-md  border-yellow-700 hover:brightness-110 transition">
          <Link to="/dashboard" className="text-black font-bold">
            Play Now
          </Link>
        </button>
      </div>
      <LandingSection
        title="How to Play Game"
        description="Follow simple steps to enjoy a smooth gaming experience"
      >
        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-12 md:mb-16 max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="flex flex-col items-center text-center group"
            >
              {/* Icon with Number */}
              <div className="relative mb-4">
                <div className="w-14 h-14 sm:h-16 sm:w-16 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center text-yellow-900 group-hover:scale-110 transition-transform shadow-lg">
                  <step.icon size={36} strokeWidth={2.5} />
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-slate-800 border-2 border-yellow-400 flex items-center justify-center text-yellow-400 font-bold text-sm">
                  {step.number}
                </div>
              </div>

              {/* Content */}
              <h3 className="text-white font-semibold text-lg mb-1">
                {step.title}
              </h3>
              <p className="text-slate-400 text-sm">{step.description}</p>
            </div>
          ))}
        </div>

        {/* Video */}
        <LazyVideo src="/how_to_play.mp4" />
      </LandingSection>
    </>
  );
};
export default Section01;
